import { Flex } from '@chakra-ui/react';
import { Card } from '@main/complykit/components/card';
import { Content } from '@main/complykit/components/slots';
import { Integration_Names_Enum } from '@main/graphql/types.generated';
import { useTranslation } from 'react-i18next';

import { IntegrationDetails } from '../integration-details';
import { IntegrationLogo } from '../integration-logo';

export type ReadonlyIntegrationCardProps = {
  providerName: Integration_Names_Enum;
  connectorName?: string;
  isDisabled: boolean;
};

export const ReadonlyIntegrationCard = ({
  providerName,
  connectorName,
  isDisabled,
}: ReadonlyIntegrationCardProps) => {
  const { t } = useTranslation('integrations');
  const helpMessage = isDisabled ? t('disabledMessage') : t('enabledMessage');

  if (!providerName) {
    return null;
  }

  return (
    <Card>
      <Content>
        <Flex align="start" gap={4}>
          <IntegrationLogo name={providerName} />
          <IntegrationDetails
            providerName={providerName}
            connectorName={connectorName}
            helpMessage={helpMessage}
          />
        </Flex>
      </Content>
    </Card>
  );
};
